import {Component, Input} from '@angular/core';
import {InlineArrayHeaderContainer} from '../inline-array-header-container';
import {FieldDisplayLabel} from '../../../core/definitions/meta-field';

@Component({
    selector: 'app-inline-array-header-value',
    templateUrl: './inline-array-header-value.component.html',
    styleUrls: ['./inline-array-header-value.component.scss'],
    standalone: false
})
export class InlineArrayHeaderValueComponent {

  @Input() label: FieldDisplayLabel;
  @Input() container: InlineArrayHeaderContainer;

  isString() {
    return !this.label.sRef && typeof this.container.values[this.label.key] === 'string';
  }

}
